<template>
	<visit-point-list
		ref="VisitPointList"
		:customConfig="visitPointListConfig"
		@showPopupVisitPointEmmit="showPopupVisitPointEmmit"
		componentParent="VisitPointAssignedList"
		:status_id="status_id"
	>
		<div>
			<vx-card ref="filterCard" :title="$t('Filters')" class="user-list-filters mb-8" no-shadow card-border>
				<vs-row vs-w="12">
					<vs-col vs-justify="center" vs-align="center" vs-lg="4" vs-sm="12" vs-xs="12">
						<label class="vs-input--label">{{ $t("SearchBy") }}</label>
						<v-select
							v-model="searchField"
							:clearable="false"
							:options="searchOptions"
							v-validate="'required'"
							name="country"
							:dir="$vs.rtl ? 'rtl' : 'ltr'"
						>
							<template v-slot:no-options="{search, searching}">
								<template v-if="searching">
									{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
								</template>
							</template>
						</v-select>
					</vs-col>

					<vs-col
						v-if="searchField.value === 'AdditionalFields'"
						vs-justify="center"
						vs-align="center"
						vs-lg="4"
						vs-sm="12"
						vs-xs="12"
					>
						<label class="vs-input--label">{{ $t("VisitPointObject.Create.SelectObjectType") }}</label>
						<v-select
							v-model="additionalField"
							:clearable="false"
							:options="additionalOptions"
							v-validate="'required'"
							name="country"
							:dir="$vs.rtl ? 'rtl' : 'ltr'"
							value="typology_name"
							label="typology_name"
							class="w-full ml-2 mr-2"
						>
							<template v-slot:no-options="{search, searching}">
								<template v-if="searching">
									{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
								</template>
							</template>
						</v-select>
					</vs-col>

					<vs-col v-else vs-justify="center" vs-align="center" vs-lg="4" vs-sm="12" vs-xs="12">
						<!-- SEARCH -->
						<div class="mt-6">
							<vs-input
								:placeholder="$t('Search')"
								v-model="searchQuery"
								@keyup.enter="searchResource"
								class="w-full ml-2 mr-2"
							/>
						</div>
					</vs-col>

					<vs-col vs-justify="center" vs-align="center" vs-lg="4" vs-sm="12" vs-xs="12">
						<div class="flex flex-wrap items-center justify-start mt-6 mb-2 ml-2">
							<vs-button
								:title="$t('Search')"
								class="ml-2"
								color="primary"
								type="border"
								icon-pack="feather"
								icon="icon-search"
								@click="searchResource"
								>{{ $t("Search") }}
							</vs-button>

							<vs-button
								:title="$t('Schedule.Refresh')"
								class="ml-2"
								color="primary"
								type="border"
								icon-pack="feather"
								icon="icon-refresh-cw"
								@click="refres"
							></vs-button>

							<vs-button
								class="ml-2"
								id="btn-locate-visit-point"
								:disabled="getCheckedVisitPoints.length <= 0"
								@click="getVisitPointSelected"
								>{{ $t("VisitPointObject.Assig") }}
							</vs-button>
						</div>
					</vs-col>
				</vs-row>

				<dinamic-fields
					v-if="additionalField"
					ref="DinamicFields"
					:additionalFields="model"
					:additionalInfo="additional_info"
					:category="additionalField"
				></dinamic-fields>
			</vx-card>

			<p class="mt-2">
				{{ $t("VisitPointObject.AssigneVisitPointText") }}
			</p>

			<vs-divider class="d-theme-border-grey-light" />
		</div>
	</visit-point-list>
</template>

<script>
import vSelect from "vue-select";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VisitPointList from "@/components/visit-point/list/VisitPointList.vue";
import DinamicFields from "@/components/DinamicFields/DinamicFields.vue";

import moduleVisitPoint from "@/store/visit-point/moduleVisitPoint.js";
import moduleCommon from "@/store/common/moduleCommon.js";

import {BadRequestError, ServerError, NotFoundError, NetworkError} from "@/helpers/handleErrors.js";

export default {
	props: {
		visit_point_ids: {
			type: Array,
			default: () => [],
		},
		multiple: {
			type: Boolean,
			default: true,
		},
		handleAssigned: {
			type: Function,
		},
	},
	components: {
		vSelect,
		VuePerfectScrollbar,
		VisitPointList,
		DinamicFields,
	},
	data() {
		return {
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			visitPointMounted: false,
			activeItem: 0,
			//Config Visit Point List
			visitPointListConfig: {
				rowSelection: this.multiple ? "multiple" : "single", // multiple | single
				activeCheckbox: true,
				activeHeaderCheckboxSelection: true,
				activeLink: false,
				columns: [
					"name",
					"identification",
					"address",
					"city",
					"typology_name",
					"status_name",
					"additional_info",
				],
				tableOptions: false,
				showItemsPerPage: false,
				showSearch: false,
				showActions: false,
				filterHead: false,
				cellRendererAdditionalFields: true,
			},
			searchQuery: "",

			searchField: {value: "Name", label: this.$t("Name")},
			dataSelect: [],
			additionalField: null,
			model: null,
			additional_info: {},
			status_id: [],
		};
	},
	computed: {
		// Integrations groups
		assignedVisitPoints() {
			return this.$store.state.moduleVisitPoint.assignedVisitPoints;
		},
		searchOptions() {
			return [
				{value: "Name", label: this.$t("Name")},
				{value: "Identification", label: this.$t("Identification")},
				{value: "Address", label: this.$t("Address")},
				{value: "City", label: this.$t("City")},
				{
					value: "AdditionalFields",
					label: this.$t("Object.AdditionalFields"),
				},
			];
		},
		additionalOptions() {
			return this.dataSelect.category;
		},
		getCheckedVisitPoints() {
			return this.$store.state.moduleVisitPoint.checkedVisitPoits;
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		getVisitPointSelected() {
			this.$refs.VisitPointList.setAssignedVisitPoint();
			this.handleAssigned();
		},
		showPopupVisitPointEmmit() {
			this.visitPointMounted = false;
			this.searchQuery = "";
		},
		removeAssignedVisitPoint(id) {
			this.$store.commit("moduleVisitPoint/REMOVE_ASSIGNED_VISIT_POINT", id);
		},
		scrollHandle(evt) {},
		searchResource() {
			if (this.$refs.DinamicFields !== undefined && this.searchField.value === "AdditionalFields") {
				// recuperamos todas las propiedades adicionales modificadas desde el componente hijo
				const additional_info = this.$refs.DinamicFields.getAddionalInfo();
				// Formato para buscar por campos adicionales [['property_name', 'property_value']]
				const formatData = Object.entries(additional_info);
				this.$refs.VisitPointList.searchByAdditionalFields([this.additionalField.typology_id], formatData, 1);
				return;
			}

			this.$refs.VisitPointList.searchResource2(this.searchField.value, this.searchQuery.trim(), 1);
		},
		refres() {
			this.$refs.VisitPointList.refreshVisitPoint();
			this.searchQuery = "";
			this.searchField = {value: "Name", label: this.$t("Name")};
		},
		getVisitPoint() {
			// Fetch to visit points list
			this.openLoading();
			this.$store
				.dispatch("moduleVisitPoint/getVisitPoints", {
					order_by: "added_on",
					sort: "DESC",
					id: this.visit_point_ids,
					assign: true,
				})
				.then((res) => {
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
		openDeleteAllConfirm() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("Alarm.DeleteAllText") + ` "${this.$t("VisitPoints")}"`,
				accept: this.deleteAll,
				acceptText: this.$t("Crud.Delete"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteAll() {
			this.$store.commit("moduleVisitPoint/CLEAR_ASSIGNED_VISIT_POINT");
		},
		async getAdditionalFields() {
			this.openLoading();
			const payload = {
				role: [],
				status: [],
				category: "VISIT_POINT",
				typology: [],
			};
			try {
				const response = await this.$store.dispatch(
					"moduleCommon/fetchDataRoleStatusCategoryTypology",
					payload
				);

				if (response.status !== 200) {
					return this.handleError(response.status);
				}

				this.dataSelect = response.data;
				this.status_id = this.dataSelect.status.filter((st) => st.name === "ACTIVE").map(({id}) => id);
				this.closeLoading();
			} catch (err) {
				this.closeLoading();
				this.throwSpecificError(err);
			}
		},
		handleError(status) {
			if (status === 401) {
				throw new BadRequestError();
			}
			if (status === 500) {
				throw new ServerError();
			}

			if (status === 722) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("Roles.Permissions.NotPermissionsTitle"),
					text: `${this.$t("Roles.Permissions.NotPermissionsText")} ${error.error}`,
					time: 5000,
				});
			}
		},
		throwSpecificError(err) {
			if (err instanceof ServerError || err instanceof NotFoundError || err instanceof NotFoundError) {
				throw err;
			}
			throw new NetworkError();
		},
	},
	watch: {
		searchField(val) {
			if (val.value !== "AdditionalFields") {
				this.additionalField = null;
				return;
			}
			//this.getAdditionalFields();
		},
		additionalField(obj) {
			this.additional_info = {};
			// this.payloadResource.typology_id = obj.value;
			let dataFields = obj.json_properties;
			dataFields = dataFields.filter((element) => element.name !== "additional_info");
			const updateData = dataFields.map((element) => {
				return {...element, error: false};
			});
			this.model = [...updateData.filter(({additional}) => additional)];
		},
		visitPointMounted(val) {
			if (!val) {
				this.additional_info = null;
				this.model = null;
				this.additionalField = null;
				this.refres();
			}
		},
	},
	created() {
		if (!moduleVisitPoint.isRegistered) {
			this.$store.registerModule("moduleVisitPoint", moduleVisitPoint);
			moduleVisitPoint.isRegistered = true;
		}

		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}

		this.getAdditionalFields();

		if (this.visit_point_ids && this.visit_point_ids.length > 0) {
			this.getVisitPoint();
		}
	},
	mounted() {
		this.searchQuery = "";
	},
	beforeDestroy() {
		this.$store.commit("moduleVisitPoint/CLEAR_ASSIGNED_VISIT_POINT");
	},
};
</script>

<style lang="scss" scoped>
#resource-create-tab-info {
	height: 100%;
}

.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 450px;
	max-height: 400px;
}

.content-form-create {
	width: 100%;
	min-height: 550px;
	max-height: 650px;
}
</style>
